import emitter from 'tiny-emitter/instance'

/*
This is just a workaround.
Vue3 removed this.$root.$on event system, so we need to use a global event bus to communicate between components.
It is used in Study Department module and should be reworked in the future to use classic Vue3 event system or Vuex/Pinia store.
https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
 */
export default {
    $on: (...args) => emitter.on(...args),
    $once: (...args) => emitter.once(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args)
}